window._ = require("lodash")
window.html2canvas = require("html2canvas")

window.axios = require("axios")
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest"

let token = document.head.querySelector('meta[name="csrf-token"]')

if (token) {
  window.axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content
} else {
  // eslint-disable-next-line
  console.error("CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token")
}
